import React from "react";
import {
  Avatar,
  Button,
  Divider,
  Stack,
  styled,
  Typography,
  LoadingButton,
  Modal,
} from "convertupleads-theme";
// import BasicModal from "./BasicModal";

const IconAvatar = styled(Avatar)(({ theme }) => ({
  width: "100px",
  height: "100px",
  backgroundColor: theme.palette.warning.light,
}));

const WarningModal = ({
  open,
  onClose,
  title = "Are you sure, you want to delete this folder?",
  warningContent = "This operation cannot be undone.",
  buttonText = "Yes, Proceed",
  cancelButtonText = "Cancel",
  onConfirm,
  isLoading,
}) => {
  return (
    <>
      <Modal
          minWidth={100}
          maxWidth={"280px"}
          open={open}
          onClose={onClose}
      >
          <Stack
              direction={"column"}
              alignItems="center"
              spacing={1}
              p={3}
              sx={{ textAlign: "center", marginInline: "auto" }}
          >
            <IconAvatar>
              <Typography
                variant={"h1"}
                sx={{ fontSize: "70px" }}
                color="warning.main"
              >
                !
              </Typography>
            </IconAvatar>
            <Typography variant="h5">{title}</Typography>
            <Typography variant="body2" color="text.tertiary">
              {warningContent}
            </Typography>
          </Stack>
          <Divider light />
          <Stack direction={"row"} alignItems={"center"} spacing={2} p={3}>
            <Button
              variant={"tonal"}
              color={"inherit"}
              onClick={onClose}
              fullWidth
            >
              {cancelButtonText}
            </Button>
            <LoadingButton
              isLoading={isLoading}
              variant={"contained"}
              color={"warning"}
              onClick={onConfirm}
              fullWidth
            >
              {buttonText}
            </LoadingButton>
          </Stack>
      </Modal>
    </>
  );
};

export default WarningModal;
